<template>
    <b-form class="step-form" @submit.stop.prevent="onSubmit">
        <div class="row">
            <div class="col-lg-8">
                <h3>Risk Profile</h3>
            </div>
            <div class="col-lg-4">
                <base-range
                    v-if="is_data_fetched"
                    v-model="rangeValue"
                    :range="toleranceResponse"
                    :value="rangeValue"
                    @input="rangeHandler"
                ></base-range>
            </div>
            <div class="col-lg-12">
                <div class="row form-options">
                    <div class="col-lg-4">
                        <!-- label="Customer's Score" -->
                        <b-form-group class="required-field">
                            <label class="urdu-label" for="" v-if="isUrdu"
                                >کسٹمر کا سکور</label
                            >
                            <label v-else>Customer's Score</label>
                            <b-form-input
                                v-model="score"
                                placeholder="Score"
                                readonly
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <!-- <div class="col-lg-4">
              <b-form-group
                  label="Tolerance"
                  class="required-field">
                  <b-form-select v-model='selectedTolerance' class="form-control" @change="onChange()" >
                      <option v-for="(data, count) in toleranceResponse"
                          v-bind:key="count" :value="data">
                      {{data.tolerance}}
                      </option>
                  </b-form-select>
              </b-form-group>
          </div>                    -->
                    <div class="col-lg-4">
                        <!-- label="Score Range" -->
                        <b-form-group class="required-field">
                            <label class="urdu-label" for="" v-if="isUrdu"
                                >اسکور کی حد</label
                            >
                            <label v-else>Score Range</label>
                            <b-form-input
                                v-model="toleranceLabel"
                                placeholder="Score"
                                readonly
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-lg-12">
                        <!-- label="Fund Risk Category" -->
                        <b-form-group class="required-field">
                            <label class="urdu-label" for="" v-if="isUrdu"
                                >فنڈ رسک کیٹیگری</label
                            >
                            <label v-else>Fund Risk Category</label>
                            <b-form-textarea
                                placeholder="Fund Risk Category"
                                v-model="toleranceSecpProduct"
                                readonly
                                rows="2"
                                max-rows="4"
                            ></b-form-textarea>
                        </b-form-group>
                    </div>
                    <div class="col-lg-12">
                        <!-- label="Recommended Fund as per Fund(s) Risk Category" -->
                        <b-form-group class="">
                            <label class="urdu-label" for="" v-if="isUrdu">
                                رسک کیٹیگری کے مطابق فنڈز
                            </label>
                            <label v-else
                                >Recommended Fund as per Fund(s) Risk
                                Category</label
                            >
                            <b-form-checkbox-group
                                class="risk-prod-checkbox"
                                v-model="value"
                                v-validate="{
                                    required: false,
                                }"
                                :options="options"
                                name="recommended fund"
                                label="name"
                                :disabled="loading || isDisabled"
                                :data-vv-name="name"
                                :class="{
                                    'is-invalid': errors.has('recommended fund'),
                                }"
                                @blur="handleBlur"
                            ></b-form-checkbox-group>
                            <!-- <multi-select
                                v-model="value"
                                v-validate="{
                                    required: true,
                                }"
                                placeholder="Select product?"
                                label="name"
                                track-by="name"
                                :name="'product'"
                                :options="options"
                                :multiple="true"
                                :taggable="true"
                            >
                            </multi-select> -->
                        </b-form-group>
                    </div>
                    <div class="col-lg-4"></div>
                    <!-- <pre class="language-json"><code>{{ value  }}</code></pre> -->
                </div>
                <div class="">
                    <b-button
                        size="sm"
                        variant="secondary"
                        class="mr-3"
                        @click="onBack"
                    >
                        Back
                    </b-button>
                    <base-button
                        btn-type="submit"
                        btn-variant="primary"
                        btn-label="CONTINUE"
                        :class="loading ? 'disabled' : ''"
                        :disabled="loading"
                    ></base-button>
                </div>
            </div>

            <b-modal
                ref="modal"
                size="lg"
                title=""
                ok-only
                :click-to-close="false"
                :no-close-on-backdrop="true"
                :no-close-on-esc="true"
            >
                <investment-modal
                    :options="options"
                    :selected-tolerance="selectedTolerance"
                >
                </investment-modal>
            </b-modal>
            <b-modal
                ref="modalDisclaimer"
                size="lg"
                title="Disclaimer"
                hide-footer
                :click-to-close="false"
                :no-close-on-backdrop="true"
                :no-close-on-esc="true"
                @close="onCloseDisclaimerModal"
            >
                <disclaimer @checked="handleDisclaimerClick"></disclaimer>
            </b-modal>
        </div>
    </b-form>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
// import request from '@/utils/request'
// import _ from 'lodash'
import MultiSelect from 'vue-multiselect'
import axios from 'axios'

import InvestmentModal from '@/components/registration/InvestmentModal.vue'
import Disclaimer from '../../components/registration/Disclaimer.vue'
import BaseRange from '../../components/registration/BaseRange.vue'
const apiUrl = process.env.VUE_APP_API_URL

export default {
    /*
  |--------------------------------------------------------------------------
  | Component > components
  |--------------------------------------------------------------------------
  */
    components: {
        MultiSelect,
        BaseRange,
        InvestmentModal,
        Disclaimer,
    }, // End of Component > components

    /*
  |--------------------------------------------------------------------------
  | Component > props
  |--------------------------------------------------------------------------
  */
    props: {}, // End of Component > props

    /*
  |--------------------------------------------------------------------------
  | Component > data
  |--------------------------------------------------------------------------
  */
    data() {
        return {
            rangeValue: 0,
            selected: [],
            selected_ids: [],
            score: '',
            toleranceResponse: '',
            selectedTolerance: '',
            toleranceProducts: [],
            selectedToleranceProduct: '',
            toleranceSecpProduct: '',
            toleranceLabel: '',
            value: [],
            options: [],
            recommandedProductsName: [],
            is_data_fetched: false,
            recommandedToleranceTemp: 0,
            toleranceResponseElements: [],
        }
    }, // End of Component > data

    /*
  |--------------------------------------------------------------------------
  | Component > computed
  |--------------------------------------------------------------------------
  */
    computed: {
        ...mapState({
            userOcr: (state) => state.registration.useOcr,
        }),

        ...mapGetters(['dataSegmentId', 'loading', 'form']),

        dataSegmentId() {
            if (this.$route.params.dataSegmentId) {
                return this.$route.params.dataSegmentId
            }
            return this.$store.getters.dataSegmentId
        },
        isUrdu() {
            let lang = this.$store.getters.getField('languageOption')
            if (lang == 'urd') {
                return true
            }
        },
    }, // End of Component > computed

    /*
  |--------------------------------------------------------------------------
  | Component > watch
  |--------------------------------------------------------------------------
  */

    watch: {}, // End of Component > methods

    /*
  |--------------------------------------------------------------------------
  | Component > Before mounted
  |--------------------------------------------------------------------------
  */
    beforeMount() {
        // this.$store.commit('initDefaultFields', 'form')
        this.calScore()
    }, // End of Component > watch

    /*
  |--------------------------------------------------------------------------
  | Component > Before mounted
  |--------------------------------------------------------------------------
  */

    mounted() {
        this.$store.dispatch('trackEvent', {event: "JS | Register Risk Product"});
        this.$store.commit('updateField', {
            key: 'investmentProduct.disclaimer',
            value: false,
        })
        // let selectedOption = this.$store.getters.getField(
        //   "investmentProduct.selectedProductsNames"
        // );
        // console.log("Selected Products", selectedOption);
        // console.log("Original Products", this.options);
    },

    /*
  |--------------------------------------------------------------------------
  | Component > methods
  |--------------------------------------------------------------------------
  */
    methods: {
        rangeHandler(event) {
            this.value = []
            this.$store.commit('updateField', {
                key: 'investmentProduct.selectedProducts',
                value: null,
            })
            this.$store.commit('updateField', {
                key: 'investmentProduct.selectedProductsNames',
                value: null,
            })
            // console.log("range clicked: " + event);
            this.rangeValue = event

            this.onSelectTolerance(this.rangeValue)
        },
        /**
         * Handle when the form has been submitted
         *
         * @return {void}
         */
        setValue(index, id) {
            //console.log(name,value);

            var self = this
            this.selected.forEach(function (val, ind) {
                if (val['index'] == index) {
                    self.selected.splice(ind, 1)
                    return false
                }
            })

            this.selected.push({
                index: index,
                id: id,
            })

            // console.log(JSON.stringify(this.selected));
        },
        calScore() {
            let score_ids = []
            let selectedOption = this.$store.getters.getField(
                'investmentProduct.selectOptions'
            )

            for (var i = 0; i < selectedOption.length; i++) {
                score_ids.push(selectedOption[i].optionId)
            }

            // console.log("Selected Answers: " + JSON.stringify(score_ids));

            let reqData = {
                dataSegmentId: this.dataSegmentId,
                score_ids: score_ids,
            }
            // console.log("reqData: " + JSON.stringify(reqData));

            // let reqData = {'score_ids':[ "608b060c5a1e28639c7353c4","608b060c5a1e28639c7353c8","608b060c5a1e28639c7353cc","608b060c5a1e28639c7353d0","608b060c5a1e28639c7353d4","608b060c5a1e28639c7353db"]}
            // console.log("reqData: "+reqData)
            // axios.post("http://127.0.0.1:3006/cal-score", reqData)
            axios
                .post(apiUrl + 'configurations/cal-score', reqData)
                .then((response) => {
                    this.score = response.data.data.score
                    this.toleranceResponse = response.data.data.listing
                    this.toleranceResponseElements = this.toleranceResponse

                    // console.log("Tolerance Response ",this.toleranceResponse)
                    /**
                     * Selection of Recommanded Product on Score Basis
                     */
                    for (let i = 0; i < this.toleranceResponse.length; i++) {
                        if (this.toleranceResponse[i].recommanded === true) {
                            this.selectedTolerance = this.toleranceResponse[i]
                            this.onSelectTolerance(i)
                            // let productNames= '';
                            this.recommandedToleranceTemp = i
                            this.rangeValue = i
                            this.is_data_fetched = true

                            // console.log(
                            //   "Recommended ",
                            //   this.toleranceResponse[i]
                            // );

                            this.$store.commit('updateField', {
                                key: 'investmentProduct.recommendedRisk.title',
                                value: this.toleranceResponse[i].tolerance,
                            })

                            for (
                                let j = 0;
                                j < this.toleranceResponse[i].products.length;
                                j++
                            ) {
                                // productNames += this.toleranceResponse[i].products[j].name+" "
                                this.recommandedProductsName.push(
                                    this.toleranceResponse[i].products[j].name +
                                        ' '
                                )
                            }

                            // alert("Recommanded products are "+JSON.stringify( this.recommandedProductsName));
                            this.$refs.modal.show()

                            let test = this.$store.getters.getField(
                                'investmentProduct.recommendedRisk'
                            )

                            // console.log("State Check", JSON.stringify(test));
                            break
                        }
                    }
                })
                .catch((error) => {
                    this.errorMessage = error.message
                    // console.error("There was an error!", error);
                })
        },
        onSelectTolerance(selectedIndex) {
            this.options = []
            // console.log("Selected Index New :" + selectedIndex);

            let toleranceData = this.toleranceResponse
            this.selectedTolerance = toleranceData[selectedIndex]
            let maxScore = toleranceData[selectedIndex].maxScore
            // console.log("Response" + toleranceData);
            // console.log("Min Score: " + maxScore);

            /**
             * Clearing Products if any
             */

            this.toleranceProducts.splice(0)

            /**
             * Adding Products up till min score of all products
             */
            // let arr = []
            for (let i = 0; i < toleranceData.length; i++) {
                if (maxScore >= toleranceData[i].minScore) {
                    for (let j = 0; j < toleranceData[i].products.length; j++) {
                        this.toleranceProducts.push(
                            toleranceData[i].products[j]
                        )
                    }
                }
            }

            this.options = this.toleranceProducts
            // console.log(this.options)
            for(let i=0; i<this.toleranceProducts.length ; i++){
                this.options[i].text = this.toleranceProducts[i].name
                this.options[i].value = this.toleranceProducts[i]._id

            }
  
            this.toleranceLabel = toleranceData[selectedIndex].lable
            this.toleranceSecpProduct =
                toleranceData[selectedIndex].secpProducts[0].name

            this.$store.commit('updateField', {
                key: 'investmentProduct.secpProduct',
                value: this.toleranceSecpProduct,
            })

            // console.log("SECP Product: " + this.$store.getters.getField('investmentProduct.secpProduct'));
            // console.log("Current Score: " + this.score);

            let disclaimer = this.$store.getters.getField(
                'investmentProduct.disclaimer'
            )

            if (disclaimer == false) {
                if (
                    this.score < toleranceData[selectedIndex].minScore &&
                    toleranceData[selectedIndex].maxScore >= this.score
                ) {
                    // alert('Disclaimer to be shown')
                    this.$refs.modalDisclaimer.show()
                }
            }
        },

        onChange() {
            let selectedIndex = this.toleranceResponse.indexOf(
                this.selectedTolerance
            )
            // console.log(selectedIndex);
            this.onSelectTolerance(selectedIndex)
        },
        handleDisclaimerClick() {
            this.$refs.modalDisclaimer.hide()
            /**
             * Setting disclaimer in state
             */
            this.$store.commit('updateField', {
                key: 'investmentProduct.disclaimer',
                value: true,
            })
        },
        async onSubmit() {
            // validate the form fields
            const result = await this.$validator.validateAll()
            // Check if validation fails
            if (result) {
                this.$store.commit('updateField', {
                    key: 'rcForms.form6.valid',
                    value: true,
                })

                let productIds = []
                let names = []

                // console.log("this.value" + JSON.stringify(this.value));

                for (var i = 0; i < this.value.length; i++) {
                    productIds.push(this.value[i])
                    for(var j =0; j< this.options.length; j++){
                        if(this.value[i] == this.options[j].value ){
                            names.push(this.options[j].name)
                        }
                    }
                    // names.push(this.value[i].name)
                    // console.log("found",found)
                    // names.push(found.name)
                }

                /**
                 * Setting score in state
                 */
                this.$store.commit('updateField', {
                    key: 'investmentProduct.score',
                    value: this.score,
                })

                /**
                 * Setting Selected Products in state
                 */
                this.$store.commit('updateField', {
                    key: 'investmentProduct.tolerance',
                    value: this.selectedTolerance.tolerance,
                })

                // console.log(
                //     'Tolerance on Submit',
                //     this.selectedTolerance.tolerance
                // )

                /**
                 * Setting Selected Products in state
                 */
                this.$store.commit('updateField', {
                    key: 'investmentProduct.selectedProducts',
                    value: productIds,
                })
                /**
                 * Setting Selected Products in state
                 */
                this.$store.commit('updateField', {
                    key: 'investmentProduct.selectedProductsNames',
                    value: names,
                })
             
                // this.$store.commit('setLoading', true)
                if (this.$route.meta.publicRegistration === true) {
                    this.$router.push({
                        name: 'public-registration-upload-document',
                        params: {
                            dataSegmentId: this.dataSegmentId,
                        },
                    })
                } else {
                    this.$router.push('/register-customer/upload-document')
                }
            } else {
                this.$store.commit('updateField', {
                    key: 'rcForms.form6.valid',
                    value: false,
                })
                this.$store.commit('setError', this.errors.all()[0])
            }
        }, // End of onSubmit() method
        onCloseDisclaimerModal() {
            this.rangeValue = this.recommandedToleranceTemp
            this.onSelectTolerance(this.recommandedToleranceTemp)
        },

        onBack() {
            if (this.$route.meta.publicRegistration === true) {
                this.$router.push({
                    name: 'public-registration-investment',
                    params: {
                        dataSegmentId: this.dataSegmentId,
                    },
                })
            } else {
                this.$router.push('/register-customer/investment')
            }
        },
    }, // End of Component > mounted
} // End of export default
</script>
